import XRegExp from 'xregexp';
import 'core-js/modules/es.object.values';

// ACCMAG-429: remove houseNumber field from VALIDATION_FIELDS once the ACCMAG-401 A/B testing is done
export const VALIDATION_FIELDS = {
  postalCode: 'postalCode',
  street: 'street',
  houseNumber: 'houseNumber',
  firstName: 'firstName',
  lastName: 'lastName',
};

export const WHITELISTED_ORIGIN_PATTERNS = [
  /^https:\/\/[a-zA-Z0-9-]+\.zooplus\.(at|de|com|co\.uk|fr|nl|pl|ie|it|be|es|fi|dk|hu|ro|ch|se|tr|pt|hr|bg|no|gr)$/,
  /^https:\/\/[a-zA-Z0-9-]+\.zoohit\.(cz|sk|si)$/,
  /^https:\/\/[a-zA-Z0-9-]+\.zoochic-eu\.ru$/,
  /^https:\/\/[a-zA-Z0-9-]+\.bitiba\.(de|co\.uk|fr|nl|pl|it|be|es|cz|fi|dk|ch|se)$/,
];

const customValidation = {};

const validationRegex = Object.values(VALIDATION_FIELDS).reduce(
  (acc, field) => {
    acc[field] = {
      custom: '',
      general: '',
    };
    return acc;
  },
  {}
);

customValidation.validateField = (fieldName, fieldValue, country) => {
  const customRegex = validationRegex[fieldName].custom;
  const generalRegex = validationRegex[fieldName].general;

  country = country.toUpperCase();

  if (country in customRegex)
    return XRegExp(customRegex[country]).test(fieldValue);
  else if (fieldName === VALIDATION_FIELDS.postalCode && country === 'IE')
    return true;
  else return XRegExp(generalRegex).test(fieldValue);
};

customValidation.setValidationRules = (fieldName, rules, general) => {
  validationRegex[fieldName].custom = rules;
  validationRegex[fieldName].general = general;
};

export default customValidation;
